import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "components/translations/useTranslation";
import Comment from "components/input/Comment.component";
import OKCancelButtons from "components/modals/OKCancelButtons";
import { MODAL_CONTENT_TAB_INDEX } from "utils/constants";
import { ModalContentProps } from "types/modals";

const Reject = ({ closeModal, loopFocus }: ModalContentProps): React.ReactElement => {
    const { translate } = useTranslation();
    const commentInputRef = useRef<HTMLTextAreaElement>(null);
    const [comment, setComment] = useState("");

    useEffect(() => {
        commentInputRef.current?.focus();
    }, []);

    return (
        <>
            <div className="ga-modal__content">
                <Comment
                    ref={commentInputRef}
                    inputHint={translate("popUp.reject.commentHint")}
                    translate={translate}
                    tabIndex={MODAL_CONTENT_TAB_INDEX}
                    id="comment"
                    shouldFocusFirst={true}
                    propagateValue={setComment}
                    value={comment}
                    label={translate("popUp.reject.commentLabel")}
                    labelState={`(${translate("popUp.required")})`}
                />
            </div>
            <OKCancelButtons
                tabIndex={MODAL_CONTENT_TAB_INDEX + 1}
                okEnabled={true}
                okCallback={closeModal}
                okText={translate("popUp.reject.rejectTask")}
                cancelEnabled={true}
                cancelCallback={closeModal}
                cancelText={translate("popUp.close")}
                loopFocus={loopFocus}
            />
        </>
    );
};

export default Reject;
